export default __webpack_public_path__ + "static/media/LED-Counter-white.cfb814f8.png";